var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
var LiveCameraService = /** @class */ (function (_super) {
    __extends(LiveCameraService, _super);
    function LiveCameraService(apiCallService) {
        var _this = _super.call(this) || this;
        _this.apiCallService = apiCallService;
        return _this;
    }
    LiveCameraService.prototype.getLiveCameras = function () {
        return this.apiCallService.get('/cameras');
    };
    LiveCameraService.prototype.getLiveCamera = function (id) {
        this.validateId(id, 'id');
        return this.apiCallService.get('/cameras/' + id);
    };
    LiveCameraService.prototype.resolve = function (route) {
        var id = route.params['friendly_id'];
        var promise;
        if (id === undefined) {
            promise = this.getLiveCameras();
        }
        else {
            promise = this.getLiveCamera(id);
        }
        return promise;
    };
    return LiveCameraService;
}(BaseApiService));
export { LiveCameraService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/live-camera.service.ts.pre-build-optimizer.js